import { css } from 'linaria';
import { cardsGrid } from 'components/items-layout/base';
import { breakpointMediumTablet } from 'common/constants';
import { breakpointSmallTablet } from 'common/constants';
import { breakpointTinyTablet } from 'common/constants';
export const contentLayout = "c1suslhj";

require("./content-layout.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./content-layout.js");